import React from 'react';
import './RadioGroup.css';

interface RadioOption {
  value: string;
  label: string;
}

interface RadioGroupProps {
  name: string;
  label: string | React.ReactNode;
  options: RadioOption[];
  value: string;
  onChange: (value: string) => void;
  onValidate?: (fieldName: string, value: string, isRequired: boolean) => void;
  required?: boolean;
  error?: string;
  exclusive?: boolean; // If true, "None" option clears others
  disabled?: boolean;
}

const RadioGroup: React.FC<RadioGroupProps> = ({
  name,
  label,
  options,
  value,
  onChange,
  onValidate,
  required = false,
  error,
  exclusive: _exclusive = false,
  disabled = false,
}) => {
  const handleChange = (optionValue: string) => {
    onChange(optionValue);
    // Validate on change (real-time validation)
    if (onValidate) {
      setTimeout(() => {
        onValidate(name, optionValue, required);
      }, 100);
    }
  };

  return (
    <div className={`form-question ${error ? 'has-error' : ''}`}>
      <fieldset className="radio-fieldset">
        <legend className="question-label">
          {label} {required && <span className="required">*</span>}
        </legend>
        <div className="radio-group" role="radiogroup" aria-required={required}>
          {options.map((option) => (
            <label key={option.value} className="radio-option">
              <input
                type="radio"
                name={name}
                value={option.value}
                checked={value === option.value}
                onChange={() => handleChange(option.value)}
                required={required}
                disabled={disabled}
              />
              <span className="radio-label">{option.label}</span>
            </label>
          ))}
        </div>
        {error && (
          <span className="error-message" id={`${name}-error`} role="alert">
            {error}
          </span>
        )}
      </fieldset>
    </div>
  );
};

export default RadioGroup;

